var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOseoauto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1428",
    "data-name": "Grupo 1428",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.1,
    height: 68.096,
    viewBox: "0 0 68.1 68.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_706",
    "data-name": "Trazado 706",
    d: "M433.928,163.855v0Zm10.858-5.525a.98.98,0,0,0,0,1.96h2.068v6.749a1.061,1.061,0,1,0,2.123,0V160.29h2.041a.98.98,0,0,0,0-1.96Zm-4.545.953v4.572c0,1.551-.789,2.34-2.1,2.34s-2.1-.816-2.1-2.394v-4.518a1.061,1.061,0,1,0-2.123,0v4.545c0,2.857,1.578,4.327,4.191,4.327,2.585,0,4.245-1.443,4.245-4.381v-4.49a1.061,1.061,0,1,0-2.123,0m-12.464,1.47,1.334,3.211h-2.667Zm-.054-2.585a1.329,1.329,0,0,0-1.252.844l-3.375,7.647h-.027a1.432,1.432,0,0,0-.109.463.982.982,0,0,0,.98,1.007,1.061,1.061,0,0,0,.98-.653l.68-1.606h4.272l.654,1.524a1.114,1.114,0,0,0,1.034.735,1.011,1.011,0,0,0,1.007-1.034,1.461,1.461,0,0,0-.109-.436l-3.374-7.647a1.3,1.3,0,0,0-1.225-.844Zm27.24,4.98a2.906,2.906,0,0,1,2.912-3.02,2.958,2.958,0,0,1,2.939,3.075,2.906,2.906,0,0,1-2.912,3.021,2.959,2.959,0,0,1-2.939-3.075m-2.231.054v.027a4.97,4.97,0,0,0,5.143,4.98,5.043,5.043,0,0,0,5.171-5.062,4.97,4.97,0,0,0-5.143-4.98,5.021,5.021,0,0,0-5.17,5.034m-6.177-16.192c-.463.218-.9.49-1.361.762a5.714,5.714,0,0,1-2.449,1.061,4.052,4.052,0,0,1-2.286-1.034,12.029,12.029,0,0,0-1.224-.735,6.321,6.321,0,0,0-4.3-.436,9.972,9.972,0,0,0-2.83,1.306,6.208,6.208,0,0,1-3.538,1.252,2.142,2.142,0,0,0-1.905.953,2.454,2.454,0,0,0-.081,2.449,2.2,2.2,0,0,0,1.932,1.2,10.963,10.963,0,0,0,5.661-1.769c.517-.272,1.034-.571,1.578-.816a1.951,1.951,0,0,1,1.959.326,9.85,9.85,0,0,0,5.008,1.932,9.246,9.246,0,0,0,4.871-1.769c.708-.435,1.524-.844,2.15-.544a8.377,8.377,0,0,1,1.388.87,12.708,12.708,0,0,0,1.279.817,8.956,8.956,0,0,0,4.218,1.034,6.682,6.682,0,0,0,.735-.027,2.336,2.336,0,0,0,2.177-2.613,2.034,2.034,0,0,0-2.286-1.96,9.566,9.566,0,0,1-3.075-.844c-.272-.163-.517-.326-.789-.49a11.614,11.614,0,0,0-2.15-1.2,4.849,4.849,0,0,0-1.894-.363,6.673,6.673,0,0,0-2.786.636m.027-7.756c-.463.218-.9.49-1.36.762a5.718,5.718,0,0,1-2.449,1.062,4.848,4.848,0,0,1-2.286-1.034,11.9,11.9,0,0,0-1.2-.735,6.325,6.325,0,0,0-4.3-.436,9.963,9.963,0,0,0-2.83,1.307,6.339,6.339,0,0,1-3.511,1.252,2.145,2.145,0,0,0-1.9.953,2.456,2.456,0,0,0-.082,2.449,2.2,2.2,0,0,0,1.932,1.2,10.41,10.41,0,0,0,5.661-1.769c.517-.272,1.061-.572,1.606-.844a1.89,1.89,0,0,1,1.959.327,9.613,9.613,0,0,0,5.007,1.932,9.435,9.435,0,0,0,4.871-1.769c1.007-.626,1.633-.789,2.123-.571a8.39,8.39,0,0,1,1.388.871,12.723,12.723,0,0,0,1.279.816,8.982,8.982,0,0,0,4.218,1.061,5.886,5.886,0,0,0,.708-.027,2.334,2.334,0,0,0,2.177-2.612,2.07,2.07,0,0,0-2.286-1.987l.055-.027a5.059,5.059,0,0,1-3.184-.762c-.272-.164-.517-.326-.762-.49a12.53,12.53,0,0,0-2.15-1.2,4.818,4.818,0,0,0-1.887-.364,6.794,6.794,0,0,0-2.794.636m0-7.728a12.941,12.941,0,0,0-1.333.762,5.524,5.524,0,0,1-2.449,1.061,4.7,4.7,0,0,1-2.286-1.034,11.758,11.758,0,0,0-1.2-.735,6.317,6.317,0,0,0-4.3-.436,10.767,10.767,0,0,0-2.83,1.306,6.412,6.412,0,0,1-3.51,1.252,2.145,2.145,0,0,0-1.9.952,2.457,2.457,0,0,0-.082,2.449,2.2,2.2,0,0,0,1.932,1.2l-.027-.027a10.782,10.782,0,0,0,5.633-1.769c.517-.3,1.061-.571,1.633-.844a1.89,1.89,0,0,1,1.959.327,7.521,7.521,0,0,0,9.878.163c.708-.436,1.524-.843,2.15-.544a12.651,12.651,0,0,1,1.388.844,9.463,9.463,0,0,0,1.306.816,9.005,9.005,0,0,0,4.245,1.061h.708a2.344,2.344,0,0,0,2.177-2.64,2.047,2.047,0,0,0-2.286-1.959,5.014,5.014,0,0,1-3.184-.762c-.245-.163-.517-.326-.762-.49a12.9,12.9,0,0,0-2.177-1.225,4.842,4.842,0,0,0-1.894-.364,6.675,6.675,0,0,0-2.787.636",
    transform: "translate(-422.961 -130.89)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.802,
    y1: 0.842,
    x2: -2.795,
    y2: 0.842,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3bf7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#3bf7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#2deddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#09d3f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ceff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1732",
    "data-name": "Rect\\xE1ngulo 1732",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1,
    height: 68.096,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.1,
    height: 67.096,
    rx: 13.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_974",
    "data-name": "Grupo 974",
    transform: "translate(-408.953 -115.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_967",
    "data-name": "Grupo 967",
    transform: "translate(422.961 130.89)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1735",
    "data-name": "Rect\\xE1ngulo 1735",
    width: 54.803,
    height: 54.803,
    transform: "translate(-18.709 18.61) rotate(-45)",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOseoauto);
export default __webpack_public_path__ + "static/media/ic_oseoauto.ad46ee032f126451efcbd77311224694.svg";
export { ForwardRef as ReactComponent };